import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import AgentsList from './AgentsList'

export default function Agents() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/agents" component={AgentsList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}